export interface IDotRezAvailabilitySimpleRequest {
    origin: string;
    destination: string;
    beginDate: string;
    endDate?: string;
    passengers: {
        types: Array<{
            type: string;
            count: number;
        }>
    },
    codes: {
        currencyCode: string;
        promotionCode?: string;
    },
    filters: {
        maxConnections: number,
        classesOfService?: string[];
        minPrice?: number,
        maxPrice?: number,
        fareInclusionType?: FareInclusionTypeEnum;
    }
}

export type IDotRezAvailabilitySimpleRequestPassengers = Array<{
    type: string;
    count: number;
}>;

export enum FareInclusionTypeEnum {
    Default = 0,
    StandBy = 1,
    Overbook = 2,
    NoPricing = 3
}